import React from "react";
import { Helmet } from "react-helmet";

const DEFAULT_SITE_NAME = "KeralaSpecial.in";
const DEFAULT_DOMAIN = "https://keralaspecialtours.com";

export default function SEOHead({
  title = "Buy Authentic Kerala Products Online | Spices, Handlooms, Kasavu Mundu & Ayurveda",
  description = "Shop 100% authentic Kerala products online at KeralaSpecial.in. Explore pure organic spices, Balaramapuram Kasavu Mundu, handlooms, traditional snacks, and Ayurvedic wellness products with worldwide shipping.",
  keywords = "Kerala Products, Buy Kerala Products Online, Authentic Kerala Products, Kerala Handlooms, Kerala Spices, Kerala Gifts, Kasavu Mundu, Elastic Kasavu Mundu, Balaramapuram Handloom, Traditional Kerala Products, Kerala Ayurveda, Kerala Snacks",
  canonical = "",
  image = "https://keralaspecialtours.com/storage/general/ks-logo.svg",
  type = "website",
  schema = null,
  noindex = false,
}) {
  const fullCanonical = canonical
    ? canonical.startsWith("http")
      ? canonical
      : `${DEFAULT_DOMAIN}${canonical}`
    : typeof window !== "undefined"
    ? window.location.href
    : DEFAULT_DOMAIN;

  const fullImage = image.startsWith("http") ? image : `${DEFAULT_DOMAIN}${image}`;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{title.includes(DEFAULT_SITE_NAME) ? title : `${title} | ${DEFAULT_SITE_NAME}`}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={DEFAULT_SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={fullImage} />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Structured Data (JSON-LD) */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
